"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORIGIN_POSITION = void 0;
exports.ORIGIN_POSITION = { x: 0, y: 0, w: 0, h: 0 };
Object.freeze(exports.ORIGIN_POSITION);
